import React, { Component } from 'react';
import { Button, Table, Dropdown, InputGroup, FormControl } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import { formatIsoDateForRuleDisplay } from '../../function';
import { PiPencil, PiTrash, PiArrowLeft, PiFileCsvDuotone } from 'react-icons/pi';
import Loader from '../../component/loader/loader';
import axios from '../../axios';
import apiError from '../../error';
import './report.css';
import CreateReportModal from '../../component/create-report';
import { toast } from 'react-toastify';
import swal from 'sweetalert';

/** Rule attributes whose filter values are stored as IDs and need lookup for display. */
const ID_RESOLVABLE_RULE_ATTRIBUTES = [
    'department',
    'designation',
    'location',
    'attack-vector',
    'campaign',
];

const emptyRuleLabelMaps = () => ({
    department: {},
    designation: {},
    location: {},
    'attack-vector': {},
    campaign: {},
});

export default class ReportEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            report: null,
            loading: true,
            dynamicReport: [],
            dynamicHeader: [],
            dynamicReportList: [],
            showCreateReportModal: false,
            reportForModal: null,
            activePage: 1,
            limit: 15,
            count: 0,
            search: '',
            ruleLabelMaps: emptyRuleLabelMaps(),
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        if (id != null && id !== '' && String(id) !== 'undefined') {
            this.fetchReport();
        } else {
            this.setState({ loading: false });
        }
        this.fetchDynamicReport();
    }

    loadRuleLabelMaps = (rules) => {
        const ruleList = Array.isArray(rules) ? rules : [];
        const needDept = ruleList.some((r) => r.attribute === 'department');
        const needDesig = ruleList.some((r) => r.attribute === 'designation');
        const needLoc = ruleList.some((r) => r.attribute === 'location');
        const needAttack = ruleList.some((r) => r.attribute === 'attack-vector');
        const needCampaign = ruleList.some((r) => r.attribute === 'campaign');
        const empty = emptyRuleLabelMaps();
        if (!needDept && !needDesig && !needLoc && !needAttack && !needCampaign) {
            return Promise.resolve(empty);
        }
        return Promise.all([
            needDept ? axios.get('/api/departments') : Promise.resolve(null),
            needDesig ? axios.get('/api/designations') : Promise.resolve(null),
            needLoc ? axios.get('/api/locations') : Promise.resolve(null),
            needAttack ? axios.get('/api/attacktypes') : Promise.resolve(null),
            needCampaign ? axios.get('/api/campaigns/list') : Promise.resolve(null),
        ])
            .then(([deptRes, desigRes, locRes, attackRes, campRes]) => {
                const maps = emptyRuleLabelMaps();
                (deptRes?.data?.departments || []).forEach((d) => {
                    maps.department[String(d.id)] = d.name;
                });
                (desigRes?.data?.designations || []).forEach((d) => {
                    maps.designation[String(d.id)] = d.name;
                });
                (locRes?.data?.locations || []).forEach((l) => {
                    maps.location[String(l.id)] = l.name;
                });
                const attackTypesList = attackRes?.data?.attackTypes || attackRes?.data?.attackVectors;
                (attackTypesList || []).forEach((a) => {
                    maps['attack-vector'][String(a.id)] = a.name;
                });
                (campRes?.data?.campaigns || []).forEach((c) => {
                    maps.campaign[String(c.id)] = c.name;
                });
                return maps;
            })
            .catch(() => empty);
    };

    fetchReport = () => {
        const { id } = this.props.match.params;
        return axios.get(`/api/custom-reports/${id}`)
            .then((res) => {
                const report = res.data.customReport;
                const rules = Array.isArray(report?.rule) ? report.rule : [];
                return this.loadRuleLabelMaps(rules).then((ruleLabelMaps) => {
                    this.setState({ report, loading: false, ruleLabelMaps });
                    return report;
                });
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    }

    normalizeReportForModal = (r) => {
        if (!r) return null;
        return {
            id: r.id ?? this.props.match.params.id,
            name: r.name ?? r.reportName ?? '',
            module: r.module ?? '',
            rule: Array.isArray(r.rule) ? r.rule : Array.isArray(r.rules) ? r.rules : [],
            sortCondition: r.sortCondition ?? r.sort_condition ?? '',
            sortingOrder: r.sortingOrder ?? r.sorting_order ?? '',
            columns: r.columns ?? []
        };
    }

    handleEditClick = () => {
        this.fetchReport().then((report) => {
            if (report) {
                const reportForModal = this.normalizeReportForModal(report);
                this.setState({
                    report,
                    reportForModal,
                    showCreateReportModal: true,
                });
            }
        });
    }

    getReportForModal = () => this.state.reportForModal;
    fetchDynamicReport = () => {
        const { id } = this.props.match.params;
        axios.get(`/api/custom-reports/dynamic/${id}`, {
            params: {
                page: this.state.activePage,
                limit: this.state.limit,
                search: this.state.search,
            }
        })
            .then(res => {
                this.setState({
                    loading: false,
                    dynamicHeader: res.data.headers,
                    dynamicReportList: res.data.reportList,
                    count: res.data.totalCount,
                });
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    }

    handleBack = () => {
        this.props.history.push('/reports');
    }
    handleExportCsv = () => {
        axios.get(`/api/custom-reports/export-csv/${this.props.match.params.id}`)
            .then(res => {
                toast.success(res.data.message);
            })
            .catch(err => apiError(err));
    }


    handleReportDelete = () => {
        const { id } = this.props.match.params;
        swal({
            title: "Are you sure you want to delete this report?",
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
        }).then(willDelete => {
            if (willDelete) {
                axios.delete(`/api/custom-Reports/${id}`)
                    .then(res => {
                        toast.success(res.data.message);
                        // this.fetchAllReports();
                        this.props.history.push('/reports');
                    })
                    .catch(err => apiError(err));
            }
        });
    }

    getColumnAlignment = (header) => {
        const columnValues = this.state.dynamicReportList.map(
            (report) => this.getCellValue(report, header)
        );

        const hasPercentage = columnValues.some(
            (val) => typeof val === "string" && val?.includes("%")
        );

        const hasNumber = columnValues.some(
            (val) => !isNaN(val) && val !== null && val !== ""
        );

        return (hasPercentage || hasNumber) ? "center" : "left";
    };
    getNormalizedKeyVariants = (header = '') => {
        const normalized = String(header || '').trim();
        const camelized = normalized
            .replace(/\s+/g, ' ')
            .split(' ')
            .map((part, index) => {
                const cleanPart = part.replace(/[^a-zA-Z0-9]/g, '');
                if (!cleanPart) return '';
                if (index === 0) return cleanPart.charAt(0).toUpperCase() + cleanPart.slice(1);
                return cleanPart.charAt(0).toUpperCase() + cleanPart.slice(1);
            })
            .join('');

        return [
            normalized,
            normalized.toLowerCase(),
            normalized.toUpperCase(),
            normalized.replace(/\s+/g, ''),
            normalized.replace(/\s+/g, '_'),
            normalized.replace(/\s+/g, '-'),
            camelized,
            'Name',
        ].filter(Boolean);
    };

    getCellValue = (row, header) => {
        if (!row || typeof row !== 'object') return '---';
        const variants = this.getNormalizedKeyVariants(header);
        const matchedKey = variants.find((key) => Object.prototype.hasOwnProperty.call(row, key));
        const value = matchedKey ? row[matchedKey] : undefined;
        return value === undefined || value === null || value === '' ? '---' : value;
    };
    formatAttributeLabel = (attribute = '') =>
        String(attribute).replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

    getOperatorLabel = (operator = '') => {
        const operatorMap = {
            in: '=',
            eq: '=',
            lt: '<',
            lte: '<=',
            gt: '>',
            gte: '>=',
            between: 'Between',
        };
        return operatorMap[operator] || operator;
    }

    getRuleValueText = (rule = {}) => {
        const maps = this.state.ruleLabelMaps || emptyRuleLabelMaps();
        if (Array.isArray(rule.arrayValues) && rule.arrayValues.length) {
            const attr = rule.attribute;
            if (ID_RESOLVABLE_RULE_ATTRIBUTES.includes(attr)) {
                const idToName = maps[attr] || {};
                return rule.arrayValues
                    .map((v) => idToName[String(v)] ?? (formatIsoDateForRuleDisplay(v) || String(v)))
                    .join(', ');
            }
            return rule.arrayValues.map((v) => formatIsoDateForRuleDisplay(v) || String(v)).join(', ');
        }
        if (rule.operator === 'between') {
            const min = rule.minRange != null ? formatIsoDateForRuleDisplay(rule.minRange) : '';
            const max = rule.maxRange != null ? formatIsoDateForRuleDisplay(rule.maxRange) : '';
            return `${min} and ${max}`.trim();
        }
        if (rule.maxRange != null && (rule.operator === 'lt' || rule.operator === 'lte')) {
            return formatIsoDateForRuleDisplay(rule.maxRange);
        }
        if (rule.minRange != null) {
            return formatIsoDateForRuleDisplay(rule.minRange);
        }
        return '';
    }

    renderRuleSummary = (rule, index) => {
        const attributeStyle = { color: '#6016C1', fontWeight: 700 };
        const operatorStyle = { color: '#167F4F', fontWeight: 700 };
        const valueText = this.getRuleValueText(rule);

        return (
            <React.Fragment key={`rule-${index}`}>
                {index > 0 && <span> <span style={operatorStyle}>AND</span> </span>}
                <span style={attributeStyle}>{this.formatAttributeLabel(rule.attribute)}</span>
                <span> </span>
                <span style={operatorStyle}>{this.getOperatorLabel(rule.operator)}</span>
                {valueText ? <span> {valueText}</span> : null}
                <span> </span>
            </React.Fragment>
        );
    }

    renderFilterText = () => {
        const { report } = this.state;
        const moduleStyle = { color: '#1967D2', fontWeight: 700 };
        const operatorStyle = { color: '#167F4F', fontWeight: 700 };
        const rules = Array.isArray(report?.rule) ? report.rule : [];

        if (!report) return null;

        return (
            <span className="report-filter-text">
                Showing <span style={moduleStyle}>{this.formatAttributeLabel(report.module || 'users')}</span>
                {rules.length ? <span> where </span> : <span> </span>}
                {rules.map((rule, index) => this.renderRuleSummary(rule, index))}
                {report.sortCondition ? (
                    <>
                        <span style={operatorStyle}>Order By</span>{' '}
                        <span>{this.formatAttributeLabel(report.sortCondition)}</span>
                        {report.sortingOrder ? <span> (<span>{String(report.sortingOrder).toUpperCase()}</span>)</span> : null}
                    </>
                ) : null}
            </span>
        );
    }

    render() {
        const { report, loading } = this.state;


        if (loading) return <Loader />;

        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-8 pl-0">
                            <div className="page-head d-flex align-items-center">
                                <div className="p-0 mr-2 circle-back-arrow" onClick={this.handleBack}>
                                    <PiArrowLeft />
                                </div>
                                <h4 className="page-title mb-0">{report?.name || 'Report'}</h4>
                            </div>
                        </div>
                        <div className="col-md-4 pr-0">
                            <div className="d-flex justify-content-end">
                                <Button variant="primary" className='btn-with-icon mr-2' onClick={this.handleExportCsv} >
                                    <PiFileCsvDuotone /> Export CSV
                                </Button>
                                <Dropdown
                                    className="action-dropdown filter-dropdown"

                                >
                                    <Dropdown.Toggle
                                        className="filter-dropdown-toggle"
                                        id="dropdown-basic"
                                    >
                                        <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item className="d-flex align-items-center" onClick={this.handleEditClick}> <PiPencil style={{ marginRight: '5px' }} /> Edit </Dropdown.Item>
                                        <Dropdown.Item className="d-flex align-items-center" onClick={this.handleReportDelete}> <PiTrash style={{ marginRight: '5px' }} /> Delete </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contentbar">
                    <div className="filter-without-border">
                        <div className="row align-items-center">
                            <div className="col-md-6 d-flex align-items-center">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} onChange={(e) => this.setState({ search: e.target.value }, () => this.fetchDynamicReport())} className="inputSearch mr-sm-2 form-control" /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>

                                <Button variant="primary" className="badge-soft-primary" style={{ fontWeight: '600' }}>Total Records: {this.state.count}</Button>
                            </div>
                            <div className="col-md-6">
                                <div className="rightFilters">
                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white">
                                            Show {this.state.limit}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[15, 25, 50, 100].map((l) => (
                                                <Dropdown.Item key={`limit-${l}`} onClick={() => this.setState({ limit: l, activePage: 1 }, () => this.fetchDynamicReport())}>{l}</Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="report-filter-text-container">
                        {this.renderFilterText()}
                    </div>
                    <div className="tableContainerWrapInner responsive-table">
                        <Table>
                            <thead>
                                <tr>
                                    {/* {
                                        this.state.dynamicHeader && this.state.dynamicHeader.map((header, index) => (
                                            <th key={index}>{header}</th>
                                        ))
                                    } */}

                                    {this.state.dynamicHeader &&
                                        this.state.dynamicHeader.map((header, index) => (
                                            <th
                                                key={index}
                                                style={{
                                                    textAlign: index === 0 ? "left" : this.getColumnAlignment(header)
                                                }}
                                            >
                                                {header}
                                            </th>
                                        ))}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.dynamicReportList.length > 0 ? (
                                        this.state.dynamicReportList.map((report, i) => (
                                            <tr key={report.id || i} className={(report.isTargetDeleted || report.email === 'User not found' || report.Email === 'User not found') ? 'report-row--deleted' : ''}>
                                                {(() => {
                                                    const firstHeader = this.state.dynamicHeader?.[0] || 'Name';
                                                    const firstColumnValue = this.getCellValue(report, firstHeader);

                                                    const firstName = report.firstName || report.Firstname || report.firstname || report.first_name || '';
                                                    const lastName = report.lastName || report.Lastname || report.lastname || report.last_name || '';
                                                    const fullName = `${firstName} ${lastName}`.trim();

                                                    const emailValue = report.email || report.Email || null;

                                                    // Mask removed-from-company users like the EVS screen:
                                                    // blur the "Abcd Xyz" name, keep "User not found" subtitle readable.
                                                    const isDeleted = report.isTargetDeleted || emailValue === 'User not found';

                                                    return (
                                                        <td>
                                                            <div className="td-heading-text">
                                                                <h6 className={isDeleted ? 'blur-text' : ''}>
                                                                    {fullName || firstColumnValue}
                                                                </h6>
                                                                {emailValue ? <p>{emailValue}</p> : null}
                                                            </div>
                                                        </td>
                                                    );
                                                })()}

                                                {this.state.dynamicHeader &&
                                                    this.state.dynamicHeader.slice(1).map((header, index) => {
                                                        const value = this.getCellValue(report, header);

                                                        return (
                                                            <td
                                                                key={index}
                                                                style={{
                                                                    textAlign: this.getColumnAlignment(header)
                                                                }}
                                                            >
                                                                {value}
                                                            </td>
                                                        );
                                                    })
                                                }

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={this.state.dynamicHeader?.length || 1}>
                                                No data found
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                    </div>
                    <div className="pagination-Wrap" style={{ border: '1px solid #dfe2e6', borderTop: 'none' }}>
                        <div className="row">
                            <div className="col-md-6">
                                {!this.state['loading'] ?
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.limit}
                                        totalItemsCount={this.state.count}
                                        onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.fetchDynamicReport())}
                                    /> : <Loader />
                                }
                            </div>
                            <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                <div className="w-100 pgCount">
                                    <p>{this.state.count === 0 ? 0 : this.state.activePage * this.state.limit + 1 - this.state.limit}-
                                        {this.state.activePage * this.state.limit > this.state.count ? this.state.count : this.state.activePage * this.state.limit} of {this.state.count} records</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CreateReportModal
                    show={this.state.showCreateReportModal}
                    onHide={() => this.setState({ showCreateReportModal: false, reportForModal: null })}
                    initialData={this.getReportForModal()}
                    onSubmit={() => {
                        this.fetchReport();
                        this.fetchDynamicReport();
                    }}
                />
            </div>
        );
    }
}